// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1NiR_","right":"Footer_right__1g2oL","buttons":"Footer_buttons__2dYPN"};